<template>
  <div class="defaultImg">
    <a
      v-if="imgList[0].Href"
      :href="imgList[0].Href"
      target="_blank"
      :style="{ backgroundImage: 'url(' + imgList[0].ImgUrl + ')' }"
    >
      <!-- <img :src="imgList[0].ImgUrl" /> -->
    </a>
    <a v-else :style="{ backgroundImage: 'url(' + imgList[0].ImgUrl + ')' }">
      <!-- <img :src="imgList[0].ImgUrl"  /> -->
    </a>
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
  created() {},
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";
[v-cloak] {
  display: none;
}
.defaultImg {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  > a {
    display: inline-block;
    height: 100%;
    width: 100%;
    text-align: center;
    vertical-align: middle;
     background-repeat: no-repeat;
    /* background-origin: top; */
    background-position: top;
    background-size: cover;
    /* img {
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-size: cover;
      background-repeat: no-repeat;
      max-height: calc(100% - 40px - 75px);
    } */
  }
}
</style>
